import PatientGoalsIcon from 'components/atoms/icons/patientGoalsIcon';
import { useTranslation } from 'react-i18next';
import HealthGoals from 'components/molecules/health-goals';
import PersonalGoals from 'components/molecules/personal-goals';
import ConditionGoals from 'components/molecules/conditions-goals';

import s from './styles.module.scss';

import type { FC } from 'react';

interface PatientSelfGoalsProps {
  patientGuid: string;
  withoutCondition?: boolean;
  disableActions?: boolean;
}

const PatientSelfGoals: FC<PatientSelfGoalsProps> = ({
  patientGuid,
  withoutCondition,
  disableActions = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className={s.wrapper} id="patient-goals">
      <div className={s['title-wrapper']}>
        <h4 className={s.title} data-cy="patient-goals-section">
          <PatientGoalsIcon />
          {t('labels.patientSelfDirectedGoals')}
        </h4>
      </div>
      <div className={s.body}>
        <HealthGoals
          patientGuid={patientGuid}
          disableActions={disableActions}
        />
        <div className={s.divider} />
        <PersonalGoals
          patientGuid={patientGuid}
          disableActions={disableActions}
        />
        {!withoutCondition && (
          <>
            <ConditionGoals patientGuid={patientGuid} />
          </>
        )}
      </div>
    </div>
  );
};
export default PatientSelfGoals;
